export const FAILURE = 'FAILURE';

export function failure (error) {
    return {
        type: FAILURE,
        payload: error
    }
}